import { api } from "./http-client";
import { Role, CreateRoleDto, UpdateRoleDto } from "../interfaces/role.interface";

export const roleService = {
  findAll: async (): Promise<Role[]> => {
    const response = await api.request<Role[]>({
      url: "/roles",
      method: "GET",
    });
    return response.data;
  },

  findOne: async (id: string): Promise<Role> => {
    const response = await api.request<Role>({
      url: `/roles/${id}`,
      method: "GET",
    });
    return response.data;
  },

  create: async (data: CreateRoleDto): Promise<Role> => {
    const response = await api.request<Role>({
      url: "/roles",
      method: "POST",
      data,
    });
    return response.data;
  },

  update: async (id: string, data: UpdateRoleDto): Promise<Role> => {
    const response = await api.request<Role>({
      url: `/roles/${id}`,
      method: "PATCH",
      data,
    });
    return response.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({
      url: `/roles/${id}`,
      method: "DELETE",
    });
  },
};
